/** Estimated seat count for Enterprise pricing discussion. */
export enum EnterpriseSalesSeatRangeEnum {
  UNSPECIFIED = "unspecified",
  FOUR_TO_TEN = "four_to_ten",
  ELEVEN_TO_TWENTYFIVE = "eleven_to_twentyfive",
  TWENTYSIX_TO_HUNDRED = "twentysix_to_hundred",
  OVER_HUNDRED = "over_hundred",
}

/** Expected concurrent workflow capacity. */
export enum EnterpriseSalesConcurrencyEnum {
  UNSPECIFIED = "unspecified",
  TWENTY_TO_FIFTY = "twenty_to_fifty",
  FIFTY_TO_HUNDRED = "fifty_to_hundred",
  HUNDRED_PLUS = "hundred_plus",
}

/** Approximate test case volume the team needs to manage (across projects). */
export enum EnterpriseSalesTestCaseScaleEnum {
  UNSPECIFIED = "unspecified",
  UNDER_ONE_HUNDRED = "under_one_hundred",
  ONE_HUNDRED_TO_FIVE_HUNDRED = "one_hundred_to_five_hundred",
  FIVE_HUNDRED_TO_TWO_THOUSAND = "five_hundred_to_two_thousand",
  TWO_THOUSAND_TO_TEN_THOUSAND = "two_thousand_to_ten_thousand",
  TEN_THOUSAND_PLUS = "ten_thousand_plus",
}

/** When the team expects to move forward. */
export enum EnterpriseSalesTimelineEnum {
  UNSPECIFIED = "unspecified",
  ASAP = "asap",
  ONE_TO_THREE_MONTHS = "one_to_three_months",
  EXPLORING = "exploring",
}

/** Enterprise capabilities the prospect is interested in. */
export enum EnterpriseSalesInterestEnum {
  ADMIN_SUB_ACCOUNTS = "admin_sub_accounts",
  SHARED_PROJECTS = "shared_projects",
  PAY_AS_YOU_GO = "pay_as_you_go",
  SSO_SECURITY = "sso_security",
  DEDICATED_SUPPORT = "dedicated_support",
}
